module.exports = __webpack_public_path__ + "static/media/back-new-1.14111598.jpg";